
import './index.css';
// import Navbar from '../src/Components/Navbar'
// import HeroSection from './Components/HeroSection';
// import UXcasestudies from './Components/UXcasestudies';
// import Footer from './Components/Footer';
// import { BrowserRouter } from "react-router-dom";
import Home from './Pages/Home';
import { Routes, Route } from "react-router-dom";
import About from './Pages/About';
import Sayhello from './Pages/Sayhello.jsx';
import Design from './Pages/Design.jsx';
import Devprojects from './Pages/Devprojects.jsx';
import Cloudmarketplace from './Pages/UXcasestudies/Cloudmarketplace.jsx'
import Analyticsdashboard from './Pages/UXcasestudies/Analyticsdashboard.jsx'
import Ecommercewebsite from './Pages/UXcasestudies/Ecommercewebsite.jsx'
import Casestudies from './Pages/Casestudies.jsx'
import FiirstVoicess from './Pages/UXcasestudies/FiirstVoicess.jsx'

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: 'GTM-14845882993' // Replace with your Container ID
};

TagManager.initialize(tagManagerArgs);








function App() {
  return (
    <div className="App">
      {/* <Navbar /> */}
      {/* <HeroSection /> */}
      {/* <UXcasestudies /> */}
      {/* <Footer />  */}

      
        <Routes>
          <Route path = '/' element = {<Home />} />
          <Route path = 'casestudies' element = {<Casestudies /> }/>
          <Route path = 'about' element = {<About />} />
          <Route path = 'sayhello' element = {<Sayhello />} />
          <Route path = 'design' element = {<Design />} />
          <Route path = 'devprojects' element = {<Devprojects />} />
          <Route path = 'marketplace' element = {<Cloudmarketplace/>}/>
          <Route path = 'analyticsdashboard' element = {<Analyticsdashboard />}/>
          <Route path = 'ecommercewebsite' element = {<Ecommercewebsite />}/>
          <Route path = 'MyPortfolioUXBtn' element = {<Casestudies />} />
          <Route path = 'FiirstVoicess' element = {<FiirstVoicess/>} />
        </Routes> 



    </div>
  );
}

export default App;
